import {
  DEVICE_ADDED,
  DEVICE_DELETED,
  DEVICE_GROUP_MEMBERSHIP_CHANGED,
  DEVICE_UPDATED,
  DEVICE_VERIFIED,
} from './device-message-type-calculator.js';
import {
  pickerDeviceAddedStrategy,
  pickerDeviceDeletedStrategy,
  pickerDeviceUpdatedStrategy,
} from './device-picker-message-strategy.js';

export const messageHandlerStrategyMapping = {
  [DEVICE_ADDED]: pickerDeviceAddedStrategy,
  [DEVICE_DELETED]: pickerDeviceDeletedStrategy,
  [DEVICE_GROUP_MEMBERSHIP_CHANGED]: pickerDeviceUpdatedStrategy,
  [DEVICE_UPDATED]: pickerDeviceUpdatedStrategy,
  [DEVICE_VERIFIED]: pickerDeviceUpdatedStrategy,
};

/**
 *
 * @param {import('unattended-iot-client/dist/types/mqttMessage').MqttMessage['type']} type
 * @returns {import('../types/message-strategy').PickerMessageStrategy | null}
 */
const pickerMessageHandlerFactory = type => messageHandlerStrategyMapping[type] || null;

export default pickerMessageHandlerFactory;
